<section>
  <div class="header astral-page-header">
    <h1>{{ 'DASHBOARD.MENU.REPORT_CHECKIN_AND_CHECKOUT_LIST' | translate }}</h1>
    <div class="astral-page-header__actions">
      <astral-button variant="primary" size="small" type="button" icon="print" labelKey="PRINT_BTN" (click)="onPrintPages()"></astral-button>
      @if (columns) {
        <app-excel-list
          [columnDefinition]="columnDefinitions"
          [selectedListViewColumns]="selectedColumns"
          [excelContext]="excelContext"
          [filter]="form.value"
          [fileName]="'In-avflyttningslista'"
        ></app-excel-list>
      }
    </div>
  </div>

  <form class="filter astral-section-surface astral-form-stack astral-form-stack--relaxed report-filter-surface" [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <astral-layout-group [columns]="6" [tabletColumns]="2" [mobileColumns]="1">
      <astral-remote-multi-select
        [service]="companyService"
        [defaultSearch]="'*'"
        [control]="form.controls['company']"
      ></astral-remote-multi-select>
      <astral-remote-multi-select
        [service]="propertyService"
        [defaultSearch]="'*'"
        [control]="form.controls['property']"
      ></astral-remote-multi-select>
      <astral-date-picker [control]="form.controls['periodFrom']"></astral-date-picker>
      <astral-date-picker [control]="form.controls['periodTo']"></astral-date-picker>
      <astral-select
        [control]="form.controls['rentalObjectCategories']"
        [itemsSource]="rentalObjectCategorySelection"
        [multiple]="true"
      ></astral-select>
    </astral-layout-group>
    <div class="astral-filter-actions">
      <astral-button variant="primary" size="small" type="submit" icon="search" labelKey="SEARCH_BTN"></astral-button>
    </div>
  </form>

  @if (dataContext) {
    <app-list-view
      [columnDefinition]="columnDefinitions"
      [itemsSource]="dataContext"
      [isToolbarSticky]="true"
      [preferencesKey]="'report.checkin-checkout'"
      (onColumnChange)="onColumnChange($event)"
    ></app-list-view>
  }
</section>
